module.exports = __webpack_public_path__ + "static/img/6.abb07c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/sp/6.png
// module id = E010
// module chunks = 0